import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GoogleOAuthProvider
    //  clientId="518226432916-slnqgpckq8dsupj3rhpm7tetdpod7dgf.apps.googleusercontent.com"
    // clientId="131663064758-6utg7ip0qm7abmr6ikp57h07nmvkf1jo.apps.googleusercontent.com"
    clientId="131663064758-6utg7ip0qm7abmr6ikp57h07nmvkf1jo.apps.googleusercontent.com"
  >
    <App />
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
